(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function openDrawerFromInlineMenu() {
    const inlineMenu = document.querySelector('.header__inline-menu');
    if (!inlineMenu) return;

    inlineMenu.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link) return;

      const summary = link.closest('summary');
      if (!summary || !inlineMenu.contains(summary)) return;

      event.preventDefault();
      event.stopPropagation();

      const summaryId = summary.id;
      if (!summaryId || !summaryId.startsWith('HeaderMenu-')) return;

      const drawerSummaryId = summaryId.replace('HeaderMenu-', 'HeaderDrawer-');
      const headerDrawer = document.querySelector('header-drawer');
      const mainDrawerSummary = headerDrawer?.querySelector('.menu-drawer-container > summary');
      const targetDrawerSummary = document.getElementById(drawerSummaryId);

      if (!headerDrawer || !mainDrawerSummary || !targetDrawerSummary) return;

      const mainDetails = mainDrawerSummary.parentElement;
      const submenuDetails = targetDrawerSummary.parentElement;
      const parentMenuElement = submenuDetails.closest('.has-submenu');
      const submenuPanel = targetDrawerSummary.nextElementSibling;

      // Close desktop mega menus so their panel cannot flash over page content
      document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((details) => {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });

      // Close any other open submenus first
      mainDetails.querySelectorAll('details[open]').forEach((details) => {
        if (details === submenuDetails) return;
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });
      mainDetails.querySelectorAll('.submenu-open').forEach((el) => el.classList.remove('submenu-open'));

      // Open submenu instantly (no slide) so it is ready before the drawer animates in
      if (submenuPanel) submenuPanel.style.transition = 'none';

      submenuDetails.setAttribute('open', '');
      submenuDetails.classList.add('menu-opening');
      targetDrawerSummary.setAttribute('aria-expanded', 'true');
      parentMenuElement?.classList.add('submenu-open');

      if (submenuPanel) {
        void submenuPanel.offsetWidth;
        submenuPanel.style.transition = '';
      }

      if (!mainDetails.hasAttribute('open')) {
        mainDrawerSummary.click();
      }

      const closeButton = submenuDetails.querySelector('.menu-drawer__close-button');
      if (closeButton && submenuPanel && typeof trapFocus === 'function') {
        setTimeout(() => trapFocus(submenuPanel, closeButton), 50);
      }
    });
  }

  function bindMenuDrawerDismiss() {
    document.addEventListener(
      'click',
      (event) => {
        const dismiss = event.target.closest('.menu-drawer__dismiss');
        if (!dismiss) return;

        event.preventDefault();
        event.stopPropagation();

        const headerDrawer = dismiss.closest('header-drawer');
        const mainSummary = headerDrawer?.querySelector('.menu-drawer-container > summary');
        if (mainSummary) mainSummary.click();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      openDrawerFromInlineMenu();
      bindMenuDrawerDismiss();
    });
  } else {
    openDrawerFromInlineMenu();
    bindMenuDrawerDismiss();
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > 20) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
